/*eslint-disable*/
import axios from "axios";
import apiConfig from "./api.config";
import { baseBackUrl } from "../assets/linkTree";

class AlmacenService {
  getAllMateriales() {
    return axios.get(baseBackUrl + "api/material", apiConfig.connData());
  }
  getAllProveedores() {
    return axios.get(baseBackUrl + "api/proveedores", apiConfig.connData());
  }
  getAllUbicaciones() {
    return axios.get(baseBackUrl + "api/ubicaciones", apiConfig.connData());
  }
  getComprasSieteDias() {
    return axios.get(
      baseBackUrl + "api/ecommerce/compras/seven_days",
      apiConfig.connData()
    );
  }
  getProductos() {
    return axios.get(
      baseBackUrl + "api/ecommerce/productos/datos",
      apiConfig.connData()
    );
  }
  getAllProductos() {
    return axios.get(
      baseBackUrl + "api/ecommerce/productos",
      apiConfig.connData()
    );
  }
  getPrediccion() {
    return axios.get(
      baseBackUrl + "api/ecommerce/compras/prediccion",
      apiConfig.connData()
    );
  }
}
export default new AlmacenService();



// WEBPACK FOOTER //
// ./src/services/AlmacenService.js